import React from 'react';
import Slider from '@material-ui/core/Slider';
import {
  StyledWrapper,
  StyledSliderContainer,
} from './CircleRangeInput.styled';

const marks = [
  {
    value: 100,
    label: '100',
  },
  {
    value: 500,
    label: '500',
  },
  {
    value: 1000,
    label: '1000',
  },
  {
    value: 2000,
    label: '2000',
  },
];

const CircleRangeInput = (props) => {
  const { radius, setRadius } = props;
  const handleChange = (event, newValue) => {
    setRadius(newValue);
  };

  return (
    <StyledWrapper
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <StyledSliderContainer>
        <Slider
          orientation='vertical'
          value={radius}
          onChange={handleChange}
          aria-labelledby='vertical-slider'
          valueLabelDisplay='auto'
          marks={marks}
          min={100}
          max={2000}
        />
      </StyledSliderContainer>
    </StyledWrapper>
  );
};

export default CircleRangeInput;
